import React from 'react'
import { Translation } from 'react-i18next'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
// import FontAwesome from 'react-fontawesome'
import classNames from 'classnames'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button, IconButton } from '@material-ui/core'
import { emailStringToArray } from '../../../utils/employer/stringArrayHandle.utils'
import { useDispatch } from 'react-redux'
import { setAssignmentFormReadOnly } from '../../../actions/employer'
import PushPinIcon from '@mui/icons-material/PushPin'
import { CloseIcon } from '../../openforwork/closeIcon.component'
import AssignmentDetails from '../../openforwork/assignmentDetails.component'
import { industryRender } from '../../../utils/showIndustry.utils'

/**
 *
 * @author Huong Nguyen
 */

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  linkHover: {
    cursor: 'pointer',
    color: '#000000',
    textDecoration: 'underline'
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewField: {
    minHeight: '70px'
  }
})

const AssignmentRow = ({
  index,
  t,
  classes,
  job_title,
  assignmentData,
  // industryType,
  location,
  // assignment_type,
  // last_date_application,
  // salary_model,
  assignment_begin,
  enterpreneur_email,
  status,
  assignment_id,
  getAssignmentById,
  deleteAssignment,
  copyAssignment,
  areaOfWorkDict,
  employerContractList,
  pinAssignment,
  pinned_assignment,
  lightEntreList,
  showSnackbarAdd,
  showSnackbarUpdate,
  companyProfile
}) => {
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = React.useState(false)
  const [assignmentId, setAssignmentId] = React.useState(-1)
  const [selectedAssignment, setSelectedAssignment] = React.useState(null)

  const entrepreneurEmailArray = emailStringToArray(enterpreneur_email)
  const lightEntre = lightEntreList.filter((el) =>
    entrepreneurEmailArray.includes(el.email)
  )

  const assignmentTypeMap = {
    until_further_notice: t('employer.assignmentType.1'),
    'until further notice': t('employer.assignmentType.1'),
    temporary: t('employer.assignmentType.2'),
    'temporary with a notice period': t('employer.assignmentType.3'),
    temporary_with_notice: t('employer.assignmentType.3'),
    until_completion: t('employer.assignmentType.4'),
    'so far until completion': t('employer.assignmentType.4')
  }

  const salaryModelMap = {
    hourly_rate: t('employer.salaryModel.1'),
    'hourly rate': t('employer.salaryModel.1'),
    contract_price: t('employer.salaryModel.2'),
    'contract price': t('employer.salaryModel.2'),
    unit_price: t('employer.salaryModel.3'),
    'unit price': t('employer.salaryModel.3'),
    commission: t('employer.salaryModel.4'),
    commission: t('employer.salaryModel.4')
  }

  // Normalize input by lowercasing and trimming spaces
  const normalizeKey = (key) => key?.toLowerCase().trim().replace(/\s+/g, ' ')

  const assignmentType =
    assignmentTypeMap[normalizeKey(selectedAssignment?.assignment_type)] || ''
  const salaryModel =
    salaryModelMap[normalizeKey(selectedAssignment?.salary_model)] || ''

  const handleEditAssignment = (id) => {
    dispatch(setAssignmentFormReadOnly(false))
    dispatch(getAssignmentById(id))
  }
  const handleCopyAssignment = (id) => {
    dispatch(setAssignmentFormReadOnly(false))
    dispatch(copyAssignment(id))
  }

  // const handleRowClick = (e) => {
  //   if (e.target.closest('.action-icon')) {
  //     return
  //   }
  //   dispatch(setAssignmentFormReadOnly(true))
  //   dispatch(getAssignmentById(assignment_id))
  // }

  React.useEffect(() => {
    if (showSnackbarAdd || showSnackbarUpdate) {
      setSelectedAssignment(null)
    }
  }, [showSnackbarAdd, showSnackbarUpdate])

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <TableRow
              key={assignment_id}
              style={
                index % 2 ? { background: 'white' } : { background: '#ebf9fa' }
              }
            >
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {/* <a className={classes.linkHover} onClick={handleRowClick}>
                  {job_title}
                </a> */}
                <u
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedAssignment(assignmentData)
                  }}
                >
                  {job_title}
                </u>
              </TableCell>
              {/* <TableCell 
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {industryRender(
                  industryType,
                  areaOfWorkDict,
                  t,
                  'employer.areaOfWork',
                  'employer.areaOfExpertiseList'
                )}
              </TableCell> */}
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {location}
              </TableCell>
              {/* <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {t(`employer.assignmentType.${assignmentType}`)}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {last_date_application}
              </TableCell> */}
              {/* <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {t(`employer.salaryModel.${salaryModel}`)}
              </TableCell> */}
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell, 'hide-mobile')}
              >
                {assignment_begin}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {enterpreneur_email !== null
                  ? entrepreneurEmailArray.length > 1
                    ? entrepreneurEmailArray.length +
                      ' ' +
                      t('employer.assignments.entrepreneurs')
                    : enterpreneur_email
                  : null}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell)}
              >
                {t(`employer.assignmentStatus.${status}`)}
              </TableCell>
              <TableCell
                scope="row"
                className={classes.tablecell}
                style={{ paddingRight: '10px', paddingLeft: '10px' }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center' }}
                  className="pull-right"
                >
                  {/* <p
                    style={{ margin: '10px 15px 10px 10px' }}
                    className="link action-icon"
                  >
                    {status === 'draft' ? (
                      <FontAwesome
                        name="pencil"
                        onClick={() => {
                          handleEditAssignment(assignment_id)
                        }}
                      />
                    ) : (
                      <FontAwesome
                        name="pencil"
                        className="fa-disable"
                        style={{ color: 'gray' }}
                      />
                    )}
                  </p>
                  {status === 'draft' ? (
                    <p style={{ margin: '10px 28px 10px 10px' }}></p>
                  ) : (
                    <p
                      style={{ margin: '10px 15px 10px 10px' }}
                      className="link"
                      onClick={() => {
                        copyAssignment(assignment_id)
                        // const section = document.getElementById(
                        //   'assignment-scroll-section'
                        // )
                        // section.scrollIntoView({ behavior: 'smooth' })
                      }}
                    >
                      <FontAwesome name="clone" />
                    </p>
                  )}
                  {employerContractList.some(
                    (item) =>
                      item.assignment_job_id === assignment_id &&
                      item.agreement_status_entrepreneur ===
                        'Offer accepted by entrepreneur'
                  ) ? (
                    <p
                      style={{
                        marginLeft: '10px',
                        color: 'gray',
                        marginTop: '10px'
                      }}
                      className="link"
                    >
                      <FontAwesome
                        title={t('employer.iconTitle.delete')}
                        name="window-close"
                        className="fa-disable"
                      />
                    </p>
                  ) : (
                    <p
                      style={{
                        marginLeft: '10px',
                        color: '#F67131',
                        marginTop: '10px'
                      }}
                      className="link"
                      onClick={() => {
                        setIsOpen(true)
                        setAssignmentId(assignment_id)
                      }}
                    >
                      <FontAwesome
                        title={t('employer.iconTitle.delete')}
                        name="window-close"
                      />
                    </p>
                  )} */}
                  <div
                    style={{
                      marginLeft: '10px'
                    }}
                  >
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      style={pinned_assignment ? { color: '#F67131' } : {}}
                      onClick={() => pinAssignment(assignment_id)}
                    >
                      <PushPinIcon />
                    </IconButton>
                  </div>
                </div>
              </TableCell>
            </TableRow>
            <Dialog
              open={isOpen}
              onClose={() => {
                setIsOpen(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('employer.assignments.dialogTitle')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('employer.assignments.dialogSubTitle')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsOpen(false)
                    }}
                  >
                    {t('employer.assignments.btn4')}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      deleteAssignment(assignmentId)
                      setIsOpen(false)
                    }}
                  >
                    {t('employer.assignments.btn5')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={selectedAssignment !== null}
              onClose={() => setSelectedAssignment(null)}
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => setSelectedAssignment(null)}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    textAlign: 'center',
                    color: '#000000',
                    fontSize: '15px'
                  }}
                >
                  {t('employer.assignments.h1d')}
                </div>
              </DialogTitle>
              <DialogContent>
                <div>
                  <AssignmentDetails
                    t={t}
                    classes={classes}
                    assignmentType={assignmentType}
                    salaryModel={salaryModel}
                    areaOfWorkDict={areaOfWorkDict}
                    industryRender={industryRender}
                    company_name={companyProfile?.company_name}
                    location={selectedAssignment?.location}
                    amount={selectedAssignment?.amount}
                    contract_salary={selectedAssignment?.contract_salary}
                    unit_price={selectedAssignment?.unit_price}
                    hourly_rate={selectedAssignment?.hourly_rate}
                    weekly_hours={selectedAssignment?.weekly_hours}
                    job_title={selectedAssignment?.job_title}
                    assignment_begins={selectedAssignment?.assignment_begins}
                    assignment_ends={selectedAssignment?.assignment_ends}
                    status={
                      selectedAssignment?.status_assignment
                        ? selectedAssignment?.status_assignment
                        : selectedAssignment?.agreement_status_entrepreneur
                    }
                    industry={selectedAssignment?.industry}
                    last_date_of_application={
                      selectedAssignment?.last_date_of_application
                    }
                    type_of_employment={selectedAssignment?.type_of_employment}
                    notice_period={selectedAssignment?.notice_period}
                    job_description={selectedAssignment?.job_description}
                    enterpreneur_email={selectedAssignment?.enterpreneur_email}
                    lightEntreList={lightEntre}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                {selectedAssignment?.status_assignment && (
                  <div className="pull-right">
                    <Button
                      variant="outlined"
                      disabled={
                        employerContractList.some(
                          (item) =>
                            item.assignment_job_id === assignment_id &&
                            item.agreement_status_entrepreneur ===
                              'Offer accepted by entrepreneur'
                        ) || selectedAssignment?.agreement_status_entrepreneur
                      }
                      onClick={() => {
                        setIsOpen(true)
                        setAssignmentId(selectedAssignment?.assignment_id)
                      }}
                    >
                      {t('employer.assignments.btn5')}
                    </Button>
                    {selectedAssignment?.status_assignment === 'draft' && (
                      <Button
                        variant="contained"
                        disabled={
                          selectedAssignment?.status_assignment !== 'draft'
                        }
                        onClick={() => {
                          handleEditAssignment(
                            selectedAssignment?.assignment_id
                          )
                        }}
                      >
                        {t('employer.assignments.btn7')}
                      </Button>
                    )}
                    {selectedAssignment?.status_assignment === 'save' && (
                      <Button
                        variant="contained"
                        onClick={() => {
                          handleCopyAssignment(
                            selectedAssignment?.assignment_id
                          )
                        }}
                      >
                        {t('employer.assignments.btn8')}
                      </Button>
                    )}
                  </div>
                )}
              </DialogActions>
            </Dialog>
          </>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(AssignmentRow)
